import React, { useEffect, useState } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Input from "aldoo-ra/Input"
import { ChangeUsername } from "aldoo-ra/PlatformAuth/api"
import { showNotification } from "aldoo-ra/Notification"
import Value from "aldoo-ra/Value"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import { motion } from "framer-motion"

const ProfileSettingsCard = ({ isExpanded, onToggle }) => {
  const [userProfile, setUserProfile] = Value("user-profile")
  const [saveMessage, setSaveMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const handleInputChange = (field) => (e) => {
    userProfile[field] = e.target.value
    setUserProfile({ ...userProfile })
  }

  const handleSave = async () => {
    try {
      await ChangeUsername(userProfile?.name)

      showNotification({
        message: saveMessage,
        className: "bg-primary text-white",
      })
      // You might want to show a success notification here
    } catch (error) {
      showNotification({
        message: errorMessage,
        className: "bg-error text-white",
      })
    }
  }

  return (
    <CMSRender
      contentType="ProfileSettingsCard"
      renderItem={(card) => {
        setTimeout(() => {
          setSaveMessage(card.save_success)
          setErrorMessage(card.save_error)
        }, 0)
        return (
          <div className="account-card shadow-custom_card relative w-full">
            {/* Chevron Toggle - Top Right Corner */}
            <button
              onClick={onToggle}
              className="absolute top-4 right-4 p-1 hover:bg-gray_2/20 rounded-full transition-colors z-10"
            >
              <ChevronDownIcon
                className={`w-6 h-6 text-text transition-transform duration-300 ${
                  isExpanded ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* Title */}
            <Typography
              variant="h5"
              className="text-text mt-0 mb-7"
            >
              {card.title}
            </Typography>

            {/* Expandable Content */}
            <motion.div
              initial={{ height: "auto", opacity: 1 }}
              animate={{ height: isExpanded ? "auto" : 0, opacity: isExpanded ? 1 : 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden w-full"
            >
              <div className="w-full space-y-[30px]">
                {/* Name Input */}
                <div className="space-y-2">
                  <Typography
                    variant="info_18_accent"
                    className="text-text my-0"
                  >
                    {card.controls[0]}
                  </Typography>

                  <Input
                    value={userProfile?.name || ""}
                    onChange={handleInputChange("name")}
                    variant="aqua_input"
                    className="w-full rounded-full bg-theme_white text-text shadow-none"
                    placeholder="Your name"
                  />
                </div>

                {/* Email Input */}
                <div className="space-y-2">
                  <Typography
                    variant="info_18_accent"
                    className="text-text my-0"
                  >
                    {card.controls[1]}
                  </Typography>

                  <Input
                    value={userProfile?.email || ""}
                    onChange={handleInputChange("email")}
                    readOnly
                    variant="aqua_input"
                    className="w-full rounded-full bg-theme_white text-text shadow-none"
                    placeholder="Billing Email"
                  />
                </div>

                {/* Save Button */}
                <div className="pt-4">
                  <Button
                    variant="primary_s"
                    onClick={handleSave}
                  >
                    {card.save[0].label}
                  </Button>
                </div>
              </div>
            </motion.div>
          </div>
        )
      }}
    />
  )
}

export default ProfileSettingsCard
